/**
 * ANCHOR: A class that scroll to next element
 *
 * - data-anchor = Target
 *
 */

;(function ($, window) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Sticky component constructor
     * @param $element
     * @param targets
     * @param auto
     */
    var Anchor = function ($element, target, auto) {
        this._$el = $element;
        this._target = target;

        /**
         * Auto-anchor as soon as we hit an `auto` = true
         */
        if (auto === true) {
            return this.toggle();
        }

        this._$el.on('click', function(e) {
            this.scroll();
            
            e.preventDefault();
            
        }.bind(this));
    };

    /**
     * Scroll funcition
     */
    Anchor.prototype.scroll = function () {
        var self=this;

        $('html, body').animate({
            scrollTop: $(this._target).offset().top
        }, 600, function() {
           // Add hash (#) to URL when done scrolling (default click behavior)
           //window.location.hash = self._target;
        });
    };

    /**
     * Attach new anchor
     * @private
     */
    Anchor.prototype._attach = function () {
        var $el = $(this),
            target = $el.data('anchor'),
            auto = $el[0].hasAttribute('data-anchor-auto') || false;

        new Anchor($el, target, auto);
    };

    /**
     * Attach listeners to document and scroll
     */
    $(function () {
        /**
         * Travel through the DOM for data-at-modal attributes
         * For each of the founded data attr create a anchor scroll
         */
        $('[data-anchor]').each(Anchor.prototype._attach);

        // *only* if we have anchor on the url
        if(window.location.hash) {
            
            var hash = decodeURI(window.location.hash);
            // smooth scroll to the anchor id
            hash = hash.replace(/[?=]/g, '');
            // console.log(hash);
            if($(hash).length > 0) {

                $('html, body').animate({
                    scrollTop: $(hash).offset().top + 'px'
                }, 1010, function(){
                    
                });    
            }
            
        }
    });


})(jQuery, window);

/*
 * Make possible to scroll to anchor by pageload
 */
// to top right away
if ( window.location.hash ) scroll(0,0);
// void some browsers issue
setTimeout( function() { scroll(0,0); }, 1);
